import React from 'react';
import { User, Shield, Clock } from 'lucide-react';

interface ClientHeaderProps {
  clientName: string;
  unifiedId: string;
  segment?: string;
  advisor?: string;
  status?: 'Active' | 'Inactive' | 'Restricted' | 'Closed';
  lastUpdated: string;
}

export const ClientHeader: React.FC<ClientHeaderProps> = ({
  clientName,
  unifiedId,
  segment,
  advisor,
  lastUpdated
}) => {
  // Format date to show month name instead of numbers
  const formatDateWithMonthName = (dateString: string): string => {
    try {
      // Parse ISO 8601 date string directly (e.g., "2026-05-14T10:01:22.981212Z")
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) {
        return dateString; // Return original if parsing fails
      }

      // Format as "Month DD, YYYY" (e.g., "May 14, 2026")
      return date.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (error) {
      return dateString; // Return original if error occurs
    }
  };

  return (
    <div className="bg-white border-b border-gray-200 px-8 py-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-start justify-between">
          <div>
            <h1 className="text-3xl mb-2">{clientName} Household</h1>
            <div className="flex items-center gap-4 text-sm text-gray-600">
              <span className="flex items-center gap-1.5">
                <Shield className="w-4 h-4" />
                Unified ID: {unifiedId}
              </span>
              {advisor && (
                <>
                  <span className="text-gray-300">|</span>
                  <span className="flex items-center gap-1.5">
                    <User className="w-4 h-4" />
                    Advisor: {advisor}
                  </span>
                </>
              )}
              {segment && (
                <>
                  <span className="text-gray-300">|</span>
                  <span>Segment: {segment}</span>
                </>
              )}
            </div>
          </div>
          <div className="text-right">
            <div className="text-xs text-gray-500 flex items-center gap-1.5 justify-end mb-1">
              <Clock className="w-3.5 h-3.5" />
              Last Updated
            </div>
            <div className="text-sm">{formatDateWithMonthName(lastUpdated)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
